
import { useState,useRef } from 'react';
import { useNavigate } from'react-router-dom';
import { Table,Button,Space,Popconfirm,Tag, message,Input,Empty } from 'antd';
import type { TableProps } from 'antd';
import ActivityContent from './components/activityContent';
import ProductContent from './components/productsContent';
import { DataType,column } from './column';
import { activityList,copyPrivWrap,cancelActivity } from '@/services/activity';
import { ResDataType } from '@/services/ajax';
import useSearchTable from '@/hooks/useList';
import MenuPermissionControl from '@/components/menuPermissionControl';
import useGetCurMenuId from '@/hooks/useGetCurMenuId';

export default function ActivitiesPage() {
  const nav = useNavigate();
  const { menuId } = useGetCurMenuId();
  const [num,setNum] = useState(0);
  const product = useRef<any>(null);
  const dialog = useRef<any>(null);
  const defaultValue = {
    Name: ''
  }
  const {
    data,
    total,
    loading,
    fetchData,
    searchParams,
    handleSearch,
    handlePageChange
  } = useSearchTable(activityList, defaultValue );
  
  const search = (e:any)=>{
    handleSearch({Name: e.target.value})
  }

  const columns: TableProps<DataType>['columns'] = [
    ...column,
    {
      title: '权益包状态',
      dataIndex: 'status',
      key: 'status',
      render: (_, record) => (
        <Tag color={record.status == 0 ? 'green' : 'red'}>
          {record.status == 0 ? '上架' : '下架'}
        </Tag>
      )
    },
      {
        title: '领取周期',
        key: 'cycle',
        width:70,
        dataIndex: 'cycle',
        render: (_, record) => (
          <>{record.cycle == 2 ? '每周' : record.cycle == 3 ? '每月' : ''}</>
        )
      },
      {
        title: '领取频率',
        key: 'cycleNum',
        dataIndex: 'cycleNum',
        width:70
      },
    // {
    //   title: '权益开始日期',
    //   dataIndex: 'startDate',
    //   key: 'startDate',
    //   width: 80,
    //   render: (_, record) => (
    //     <>{record.startDate && dayjs(record.startDate).format('YYYY-MM-DD HH:mm:ss')}</>
    //   )
    // },
    // {
    //   title: '权益结束日期',
    //   dataIndex: 'endDate',
    //   key: 'endDate',
    //   width: 80,
    //   render: (_, record) => (
    //     <>{record.endDate && dayjs(record.endDate).format('YYYY-MM-DD HH:mm:ss')}</>
    //   )
    // },
    
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      render: (_, record) => (
        <MenuPermissionControl menuId={menuId} operation="edit" >
          <Space size="middle">
            <Button onClick={()=>{
              openDialog(dialog,record.id,null,'edit')
            }}>编辑</Button>
            <Button onClick={()=>{
              //  productSetting(record,'product')
              nav(`/main/activityProducts/${record.id}`,{
                state:{
                  status:record.status
                }
              })
            }}>权益配置</Button>
             <Popconfirm
              title="提示"
              description="确定复制该权益包吗?"
              okText="确定"
              cancelText="取消"
              onConfirm={()=> copyWrap(record.id)}
            >
              <Button danger>复制</Button>
            </Popconfirm>
            <Popconfirm
              title="提示"
              disabled={record.status == 0}
              description="确定失效该权益包吗?"
              okText="确定"
              cancelText="取消"
              onConfirm={()=> cancelWrap(record.id)}
            >
              <Button disabled={record.status == 0} danger>失效</Button>
            </Popconfirm>
            {/* <Popconfirm
              title="提示"
              disabled={record.status == 0}
              description="确定删除该权益包吗?"
              okText="确定"
              cancelText="取消"
              onConfirm={()=> handleDelete(record.id)}
            >
              <Button disabled={record.status == 0} danger>删除</Button>
            </Popconfirm> */}
            {/* <Switch checkedChildren="已上架" unCheckedChildren="已下架" checked={record.status == 0 ? true : false} onChange={(e)=>{
              handleChangeStatus(record.id,e ? 0 : 1)
            }} /> */}
          </Space>
        </MenuPermissionControl>
      ),
    }
  ];

  const productSetting = async (row?:DataType,type?:string) => {
    if (type == 'edit') {
      await handleSearch()
    } else {
      nav(`/main/activityProducts/${row?.id}`,{
        state:{
          status:row?.status
        }
      })
    }
    // openDialog(product,null,row)
  }

  const copyWrap = async (id:number) => {
    const res = await copyPrivWrap(id) as ResDataType;
    if (res.code == 0) {
      message.success('复制成功');
    } else {
      message.error(res.message);
      return
    }
    handleSearch();
  }  

  const cancelWrap = async (id:number) => {
    const res = await cancelActivity(id) as ResDataType;
    if (res.code == 0) {
      message.success('失效成功');
    } else {
      message.error(res.message);
      return
    }
    handleSearch();
  }  

    const openDialog = (name:any,id?:number|null,record?:DataType | null,type?:string) => {
      name.current?.open(type,id,record);
    }

  return (
    <>
      <div className="headerTitle">
        <div>
          <h2>权益包管理</h2>
        </div>
        
      </div>

      <div className="card m-6">
      {/* 搜索功能 */}
      <div className="mb-4">
        <div className="searchCond">
          <Space size="middle">
            <Input style={{ width:'250px' }} allowClear placeholder="权益包标题"  onPressEnter={search} size='large' onChange={search}/>
              <Button type="primary" size='large' onClick={()=>{ fetchData() }}>搜索</Button>
            <Button type="primary" size='large' onClick={()=>{ nav('/main/products') }}>权益管理</Button>
            <MenuPermissionControl menuId={menuId} operation="edit" >
              <Button type="primary" size='large'
                onClick={() => openDialog(dialog,null,null,'add')}
              >
                <span>创建权益包</span>
              </Button>
            </MenuPermissionControl>
          </Space>
        </div>
      </div>
      <Table<DataType>
        rowKey='id'
        columns={columns} 
        dataSource={data as DataType[]}
        loading={loading}
        pagination={{ current: searchParams.PageIndex, pageSize:searchParams.PageSize, total, onChange: handlePageChange ,showSizeChanger:false }}
        scroll={{ x: 'max-content', y: 580 }}
        locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
        />
        
      </div>
      <ActivityContent ref={dialog} save={productSetting} refresh={handleSearch}/>
      <ProductContent ref={product} num={num}/>
    </>
  );
} 